import FileMeta from './FileMeta'

/**
 * @member {FileMeta} meta
 * @member {string} mediaType
 * @member {string|null} mimeType
 * @member {string} src
 * @member {string} thumb
 * @member {string} title
 */
export default class VisitorDocumentListItem {
  meta
  mediaType
  mimeType
  src
  thumb
  title

  /**
   * @param {FileMeta} meta
   * @param {string} mediaType
   * @param {string|null} mimeType
   * @param {string} src
   * @param {string} thumb
   * @param {string} title
   */
  constructor({
    meta,
    mediaType,
    mimeType,
    src,
    thumb,
    title
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: true
    }

    meta = new FileMeta(meta)
    mediaType = String(mediaType)
    mimeType = mimeType ? String(mimeType) : null
    src = String(src)
    thumb = String(thumb)
    title = String(title)

    Object.defineProperty(this, 'meta', Object.assign({ value: meta }, properties))
    Object.defineProperty(this, 'mediaType', Object.assign({ value: mediaType }, properties))
    Object.defineProperty(this, 'mimeType', Object.assign({ value: mimeType }, properties))
    Object.defineProperty(this, 'src', Object.assign({ value: src }, properties))
    Object.defineProperty(this, 'thumb', Object.assign({ value: thumb }, properties))
    Object.defineProperty(this, 'title', Object.assign({ value: title }, properties))
    Object.freeze(this)
  }
}
